/**
 * Smatchy
 * The smatchy API description. Use POST /auth/login to get an access token.
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface AdminActivityDetailScheduleDto { 
    startDate: string;
    endDate?: string;
    /**
     * Duration in seconds.
     */
    duration: number;
    /**
     * Weekly recurrence when the activity is recurring.
     */
    recurrence?: AdminActivityDetailScheduleDto.RecurrenceEnum | null;
}
export namespace AdminActivityDetailScheduleDto {
    export type RecurrenceEnum = 'weekly';
    export const RecurrenceEnum = {
        Weekly: 'weekly' as RecurrenceEnum
    };
}


